/* eslint-disable jsx-a11y/alt-text */
import React, { Fragment, PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { shopContext } from '../../contexts/aniplus';
import axios from 'axios';
import StillItem from '../../components/guestBook/StillItem';

//import socketio from 'socket.io-client';
//import $ from 'jquery';
//import socket from 'socket.io-client/lib/socket';
//const socket = socketio.connect('https://socket.aniplustv.com:4100')

class CardImage extends PureComponent {
  state = {};
  componentDidMount = () => {
    const { selectContentSerial } = this.props.childProps;
    //console.log(selectContentSerial)
    this._getData(selectContentSerial);
  };
  componentWillReceiveProps = (nextProps) => {
    ////console.log(nextProps)
    if (
      this.props.childProps.selectContentSerial !==
      nextProps.childProps.selectContentSerial
    ) {
      this._getData(nextProps.childProps.selectContentSerial);
    }
  };
  _getData = async (contentSerial) => {
    const result = await this._getDataApi(contentSerial);
    const intReturn = result.data[0].intReturn;
    const stillList = result.data[0].listData;

    //console.log(contentSerial)

    if (intReturn === 0) {
      this.setState({
        stillList,
      });
    } else {
    }
  };
  _getDataApi = (contentSerial) => {
    const { apiUrl1 } = this.props;
    return axios.post(apiUrl1 + '/cardStill', {
      params: {
        contentSerial: contentSerial,
      },
    });
  };
  _renderItem = () => {
    const { selectStillSerial, selectStill } = this.props.childProps;
    const { stillList } = this.state;

    const list = stillList.map((item, index) => {
      return (
        <StillItem
          key={index}
          stillSerial={item.stillSerial}
          thumb={item.thumb}
          photo={item.photo}
          selectStillSerial={selectStillSerial}
          selectStill={selectStill}
        />
      );
    });

    return list;
  };
  _pre = () => {
    const { step, pre } = this.props.childProps;

    pre(step - 1);
  };
  _next = () => {
    const { step, next, selectStillSerial } = this.props.childProps;
    //console.log(step)
    if (
      selectStillSerial === 0 ||
      selectStillSerial === null ||
      selectStillSerial === undefined
    ) {
    } else {
      next(step + 1);
    }
  };
  render() {
    const { type } = this.props.childProps;
    const { stillList } = this.state;
    const { imgUrl } = this.props;

    return (
      <Fragment>
        <header className="header1">
          <nav className="nav">
            <button
              type="button"
              className="menuCtrl"
              onClick={this._pre}
              style={{ fontFamily: 'GmarketSansBold' }}
            >
              이전
            </button>
          </nav>
        </header>
        <div className="container_wall">
          <div className="guestBook ctrl">
            <div className="ctrl_head">
              <h1 style={{ fontFamily: 'GmarketSansBold' }}>방명록</h1>
              <h3 className="dsc" style={{ fontFamily: 'GmarketSansBold' }}>
                원하시는 작품으로 당신의 소중한 발자취를 남겨주세요!
              </h3>
              <ol className="step">
                <li>
                  <span style={{ fontFamily: 'GmarketSansBold' }}>
                    1. 작품선택
                  </span>
                </li>
                <li className="active">
                  <span style={{ fontFamily: 'GmarketSansBold' }}>
                    2. 스틸컷 선택
                  </span>
                </li>
                <li>
                  <span style={{ fontFamily: 'GmarketSansBold' }}>
                    3. 메모지 선택
                  </span>
                </li>
                {type === 'tablet' ? (
                  <li>
                    <span style={{ fontFamily: 'GmarketSansBold' }}>
                      4. 방명록 남기기
                    </span>
                  </li>
                ) : null}
              </ol>
            </div>

            <div className="ctrl_body">
              <div className="list stil">
                <ul style={{ marginBottom: 80 }}>
                  {stillList ? this._renderItem() : null}
                </ul>
              </div>
            </div>
            <div className="m_pagination">
              <p>(총 {stillList ? stillList.length : 0}개)</p>
              <button type="button">
                <img src={imgUrl + '/img/guestBook/arrw_down.png'} />
              </button>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}
export default shopContext(withRouter(CardImage));
